import React, { useEffect, useState } from 'react'
import Fixxbank from '../Sections/Fixxbank'
import Menu from '../Components/Menu'
import '../Styles/Home.css'
import Fixxinvest from '../Sections/Fixxinvest'
import AOS from 'aos'
import 'aos/dist/aos.css'
import StarAgency from '../Sections/StarAgency'
import StarCorporate from '../Sections/StarCorporate'
import ChickeninHouse from '../Sections/ChickeninHouse'
import Agtech from '../Sections/Agtech'
import Nexxfixx from '../Sections/Nexxfixx'
import MCompany from '../Sections/MCompany'
import FixxCapital from '../Sections/FixxCapital'
import FxVidroEsquadrias from '../Sections/FxVidroEsquadrias'
import Agrofixx from '../Sections/Agrofixx'

const Home = () => {
  const [activeSection, setActiveSection] = useState('Fixxinvest')

  useEffect(() => {
    AOS.init({
      duration: 1000,
    })

    const sections = document.querySelectorAll('section')
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setActiveSection(entry.target.id)
          }
        })
      },
      {
        threshold: 0.1,
      }
    )

    sections.forEach((section) => {
      observer.observe(section)
    })

    return () => {
      sections.forEach((section) => {
        observer.unobserve(section)
      })
    }
  }, [])

  return (
    <div className="home">
      <Menu activeSection={activeSection} />
      <main className="container-sections flex-center flex-column">
        <Fixxinvest id="Fixxinvest" />
        <Fixxbank id="FixxBank" />
        <FixxCapital id="FixxCapital" />
        <FxVidroEsquadrias id="FxVidroEsquadrias" />
        <Agrofixx id="AgroFixx" />
        <ChickeninHouse id="Chicken in House" />
        <StarAgency id="Star Agency" />
        <StarCorporate id="Star Corporate" />
        <Agtech id="AGTEK" />
        <Nexxfixx id="NexxFixx" />
        <MCompany id="MCompany" />
      </main>
    </div>
  )
}

export default Home
